"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function ({outline, fn}) {
        this.state = {
            searchResults: [],
            suggestions: []
        };
        this.fhandler = new FormHandler();
        const {title, description, schedule} = outline;
        this.fhandler.bind(this, {
            title,
            description,
            schedule: {
                start: {},
                end: {},
                ...schedule || {}
            }
        });
        this.callbackFn = fn;
    },
    onMount: function () {
        setTimeout(() => {
            const self = this, $dateInput = $('.pickadate'), $timeInput = $('.pickatime');
            if ($dateInput.length)
                $dateInput.pickadate({
                    format: 'mmmm dd, yyyy',
                    min: true,
                    onSet: function () {
                        self.fhandler.set($('#' + this.get('id')).attr('name'), this.get());
                    }
                });
            if ($timeInput.length)
                $timeInput.pickatime({
                    formatLabel: 'HH:i a',
                    formatSubmit: 'HH:i',
                    hiddenPrefix: 'prefix__',
                    hiddenSuffix: '__suffix',
                    interval: 30,
                    onSet: function () {
                        self.fhandler.set($('#' + this.get('id')).attr('name'), this.get());
                    }
                });
        }, 200);
    },
    onSave: function () {
        if (!this.state.form.title)
            return this.fhandler.error('name');
        typeof this.callbackFn == 'function' && this.callbackFn(this.state.form);
        this.emit('dismiss');
    },
    onSearchResult: function (results) {
        this.state.searchResults = results;
        this.state.suggestions = results.map(({profile, account}) => {
            return {
                poster: {
                    type: 'image',
                    value: profile.photo
                },
                title: getFullname(profile),
                subtitle: profile.email
            };
        });
    },
    onSearchDismiss: function () {
        this.state.suggestions = [];
    },
    onSelectSuggestion: function (index) {
        const {profile, instructor} = this.state.searchResults[index], isAdded = this.instructors.filter(({email}) => {
                return profile.email == email;
            }).length;
        if (isAdded)
            return;
        this.instructors.push({
            photo: profile.photo,
            name: getFullname(profile),
            email: profile.email,
            title: instructor.title,
            departments: instructor.department
        });
        fhandler.set('instructors', this.instructors);
    },
    removeInstructor: function (arg) {
        this.instructors = this.instructors.filter(({email}) => {
            return email !== arg;
        });
        fhandler.set('instructors', this.instructors);
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Programs/create/Content/components/EditOutline.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    Locale_template = require("../../../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    Row_template = require("../../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    _preserve_tag = marko_loadTag(require("marko/dist/core-tags/components/preserve-tag")),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Image_template = require("../../../../../../components/Image/index.marko"),
    Image_tag = marko_loadTag(Image_template),
    SearchBar_template = require("../../../../../../components/SearchBar/index.marko"),
    SearchBar_tag = marko_loadTag(SearchBar_template),
    WSAdapt_template = require("../../../../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    marko_attrs0 = {
        "class": "position-absolute zindex-2 w-100 h-100 top-0 left-0 d-flex align-items-center center"
      },
    marko_attrs1 = {
        "class": "position-fixed top-0 w-100 h-100 theme-bg-transparent animated fadeIn faster"
      },
    marko_attrs2 = {
        "class": "text-muted"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("9fd684"),
    marko_node0 = marko_createElement("br", null, "8", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "form-group"
      },
    marko_node1 = marko_createElement("br", null, "12", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs4 = {
        "class": "form-group"
      },
    marko_node2 = marko_createElement("br", null, "19", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs5 = {
        "class": "form-group"
      },
    marko_attrs6 = {
        "class": "position-relative"
      },
    marko_node3 = marko_createElement("br", null, "66", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs7 = {
        "class": "col"
      },
    marko_attrs8 = {
        "class": "form-group"
      },
    marko_attrs9 = {
        "class": "col-4"
      },
    marko_attrs10 = {
        "class": "form-group"
      },
    marko_attrs11 = {
        "class": "col"
      },
    marko_attrs12 = {
        "class": "form-group"
      },
    marko_attrs13 = {
        "class": "col-4"
      },
    marko_attrs14 = {
        "class": "form-group"
      },
    marko_node4 = marko_createElement("br", null, "55", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs15 = {
        "class": "list-inline"
      },
    marko_attrs16 = {
        "class": "mr-2"
      },
    marko_attrs17 = {
        "class": "chip pl-0 theme-bg-lighten round"
      },
    marko_attrs18 = {
        "class": "chip-body font-medium-2 d-flex align-items-center"
      },
    marko_attrs19 = {
        style: "width:35px;height:35px;margin-left:3px"
      },
    marko_attrs20 = {
        "class": "chip-text pl-75 py-50"
      },
    marko_attrs21 = {
        "class": "chip-closeable p-50 m-50"
      },
    marko_attrs22 = {
        "class": "bx bx-x white-text"
      },
    marko_attrs23 = {
        "class": "col-7"
      },
    marko_attrs24 = {
        "class": "btn btn-secondary m-25"
      },
    marko_attrs25 = {
        "class": "col text-right"
      },
    marko_attrs26 = {
        "class": "btn btn-primary m-25"
      };

require("~/../public/vendors/pickadate/js/picker");

require("~/../public/vendors/pickadate/js/picker.date");

require("~/../public/vendors/pickadate/js/picker.time");

require("~/../public/vendors/pickadate/js/legacy");

require("~/../public/vendors/pickadate/css/pickadate.css");

require("~/../public/vendors/pickadate/css/classic.css");

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  Row_tag({
      class: "m-0 w-100 d-flex justify-content-center",
      renderBody: function(out) {
        out.e("div", marko_attrs1, "2", component, 0, 0, {
            onclick: __component.d("click", () => component.emit('dismiss'), false)
          });

        WSAdapt_tag({
            ns: "col-9",
            qs: "col-9",
            hs: "col-10",
            class: "animated zoomIn faster",
            style: "padding-bottom:150px",
            renderBody: function(out) {
              out.be("h5", null, "4", component);

              Locale_tag({
                  text: "Edit Outline"
                }, out, __component, "5");

              out.ee();

              out.be("p", marko_attrs2, "6", component);

              Locale_tag({
                  renderBody: function(out) {
                    out.t("Note that any changes made here have no repercution on the original course or activity details.");
                  }
                }, out, __component, "7");

              out.ee();

              out.n(marko_node0, component);

              out.be("div", marko_attrs3, "9", component);

              out.be("label", null, "10", component);

              Locale_tag({
                  text: "Title",
                  class: "text-muted"
                }, out, __component, "11");

              out.ee();

              out.n(marko_node1, component);

              out.e("input", {
                  type: "text",
                  value: state.form.title,
                  name: "title",
                  "class": marko_classValue("form-control form-control-xl px-2" + (state.formError.title != undefined ? state.formError.title ? " is-invalid" : " is-valid" : "")),
                  validate: "required",
                  placeholder: Locale("Title*")
                }, "13", component, 0, 0, {
                  onchange: __component.d("change", "__onChange", false)
                });

              out.be("p", {
                  "class": marko_classValue("small mt-50 mb-2" + (!state.formError.title ? " d-none" : ""))
                }, "14", component, null, 1);

              Locale_tag({
                  text: "This field is required"
                }, out, __component, "15");

              out.ee();

              out.ee();

              out.be("div", marko_attrs4, "16", component);

              out.be("label", null, "17", component);

              Locale_tag({
                  text: "Description",
                  class: "text-muted"
                }, out, __component, "18");

              out.ee();

              out.n(marko_node2, component);

              out.e("textarea", {
                  value: state.form.description,
                  name: "description",
                  "class": marko_classValue("form-control form-control-xl px-2 " + (state.formError.description != null ? state.formError.description ? " is-invalid" : " is-valid" : "")),
                  placeholder: Locale("Description"),
                  style: marko_styleValue({
                      height: "100px",
                      resize: "none"
                    })
                }, "20", component, 0, 0, {
                  onchange: __component.d("change", "__onChange", false)
                });

              out.ee();

              out.be("div", null, "21", component);

              _preserve_tag({
                  n: true,
                  b: true,
                  renderBody: function(out) {
                    Row_tag({
                        renderBody: function(out) {
                          out.be("div", marko_attrs7, "23", component);

                          out.be("div", marko_attrs8, "24", component);

                          out.be("label", null, "25", component);

                          Locale_tag({
                              text: "Start Date",
                              class: "text-muted"
                            }, out, __component, "26");

                          out.ee();

                          out.e("input", {
                              type: "text",
                              value: state.form.schedule.start.date,
                              name: "schedule.start.date",
                              "class": "form-control form-control-lg px-2 pickadate",
                              placeholder: Locale("January 01, 2021")
                            }, "27", component, 0);

                          out.be("p", {
                              "class": marko_classValue("small mt-50 mb-2" + (!state.formError["schedule.start.date"] ? " d-none" : ""))
                            }, "28", component, null, 1);

                          Locale_tag({
                              text: "Invalid Date Format"
                            }, out, __component, "29");

                          out.ee();

                          out.ee();

                          out.ee();

                          out.be("div", marko_attrs9, "30", component);

                          out.be("div", marko_attrs10, "31", component);

                          out.be("label", null, "32", component);

                          Locale_tag({
                              text: "Start Time",
                              class: "text-muted"
                            }, out, __component, "33");

                          out.ee();

                          out.e("input", {
                              type: "text",
                              value: state.form.schedule.start.time,
                              name: "schedule.start.time",
                              "class": "form-control form-control-lg px-2 pickatime",
                              placeholder: "11:30",
                              validate: "time"
                            }, "34", component, 0);

                          out.be("p", {
                              "class": marko_classValue("small mt-50 mb-2" + (!state.formError["schedule.start.time"] ? " d-none" : ""))
                            }, "35", component, null, 1);

                          Locale_tag({
                              text: "Invalid Time Format"
                            }, out, __component, "36");

                          out.ee();

                          out.ee();

                          out.ee();
                        }
                      }, out, __component, "22");

                    Row_tag({
                        renderBody: function(out) {
                          out.be("div", marko_attrs11, "38", component);

                          out.be("div", marko_attrs12, "39", component);

                          out.be("label", null, "40", component);

                          Locale_tag({
                              text: "End Date",
                              class: "text-muted"
                            }, out, __component, "41");

                          out.ee();

                          out.e("input", {
                              type: "text",
                              value: state.form.schedule.end.date,
                              name: "schedule.end.date",
                              "class": "form-control form-control-lg px-2 pickadate",
                              placeholder: Locale("January 01, 2021")
                            }, "42", component, 0);

                          out.be("p", {
                              "class": marko_classValue("small mt-50 mb-2" + (!state.formError["schedule.end.date"] ? " d-none" : ""))
                            }, "43", component, null, 1);

                          Locale_tag({
                              text: "Invalid Date Format"
                            }, out, __component, "44");

                          out.ee();

                          out.ee();

                          out.ee();

                          out.be("div", marko_attrs13, "45", component);

                          out.be("div", marko_attrs14, "46", component);

                          out.be("label", null, "47", component);

                          Locale_tag({
                              text: "End Time",
                              class: "text-muted"
                            }, out, __component, "48");

                          out.ee();

                          out.e("input", {
                              type: "text",
                              value: state.form.schedule.end.time,
                              name: "schedule.end.time",
                              "class": "form-control form-control-lg px-2 pickatime",
                              placeholder: "11:30",
                              validate: "time"
                            }, "49", component, 0);

                          out.be("p", {
                              "class": marko_classValue("small mt-50 mb-2" + (!state.formError["schedule.end.time"] ? " d-none" : ""))
                            }, "50", component, null, 1);

                          Locale_tag({
                              text: "Invalid Time Format"
                            }, out, __component, "51");

                          out.ee();

                          out.ee();

                          out.ee();
                        }
                      }, out, __component, "37");
                  }
                }, out, __component, "21");

              out.ee();

              out.be("div", marko_attrs5, "52", component);

              out.be("label", null, "53", component);

              Locale_tag({
                  text: "Instructors",
                  class: "text-muted"
                }, out, __component, "54");

              out.ee();

              if (Array.isArray(state.form.instructors) && state.form.instructors.length) {
                out.n(marko_node4, component);

                out.be("ul", marko_attrs15, "56", component);

                marko_forOf(state.form.instructors, function({ photo, title, name, email }, index) {
                  var $keyValue$0 = "@" + ("inst-" + index),
                      $keyScope$0 = "[" + ($keyValue$0 + "]");

                  out.be("li", marko_attrs16, $keyValue$0, component);

                  out.be("div", marko_attrs17, "57" + $keyScope$0, component);

                  out.be("div", marko_attrs18, "58" + $keyScope$0, component);

                  out.be("div", marko_attrs19, "59" + $keyScope$0, component);

                  Image_tag({
                      alt: "avatar",
                      src: photo,
                      class: "img-fluid rounded-circle"
                    }, out, __component, "60" + $keyScope$0);

                  out.ee();

                  out.e("span", marko_attrs20, "61" + $keyScope$0, component, 3)
                    .t(title, component)
                    .t(" ")
                    .t(name, component);

                  out.e("div", marko_attrs21, "62" + $keyScope$0, component, 1, 0, {
                      onclick: __component.d("click", "removeInstructor", false, [
                          email
                        ])
                    })
                    .e("i", marko_attrs22, "63" + $keyScope$0, component, 0);

                  out.ee();

                  out.ee();

                  out.ee();
                });

                out.ee();
              }

              out.be("div", marko_attrs6, "64", component);

              SearchBar_tag({
                  size: "xl",
                  icon: "bx-user",
                  target: "user",
                  minLength: 3,
                  filters: {
                      type: "instructor"
                    },
                  suggestions: state.suggestions,
                  placeholder: Locale("Find instructor ...")
                }, out, __component, "65", [
                [
                  "blur",
                  "onSearchDismiss",
                  false
                ],
                [
                  "result",
                  "onSearchResult",
                  false
                ],
                [
                  "select",
                  "onSelectSuggestion",
                  false
                ]
              ]);

              out.ee();

              out.ee();

              out.n(marko_node3, component);

              Row_tag({
                  renderBody: function(out) {
                    out.be("div", marko_attrs23, "68", component);

                    out.be("button", marko_attrs24, "69", component, null, 0, {
                        onclick: __component.d("click", () => component.emit('dismiss'), false)
                      });

                    Locale_tag({
                        text: "Cancel"
                      }, out, __component, "70");

                    out.ee();

                    out.ee();

                    out.be("div", marko_attrs25, "71", component);

                    out.be("button", marko_attrs26, "72", component, null, 0, {
                        onclick: __component.d("click", "onSave", false)
                      });

                    Locale_tag({
                        text: "Save"
                      }, out, __component, "73");

                    out.ee();

                    out.ee();
                  }
                }, out, __component, "67");
            }
          }, out, __component, "3");
      }
    }, out, __component, "1");

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
